var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loading"},[_c('span',{staticClass:"left"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('global.没有更多了')))]),_vm._v(" "),_c('span',{staticClass:"right"})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37cc2cf2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/NoMore.vue
// module id = null
// module chunks = 